import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "loading",
  "use": "loading-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"loading\"><path d=\"M14.303 18.727h-3.436L3.67 5.273h10.066c4.043.008 7.262 3.172 7.265 7.007-.007 3.536-2.972 6.447-6.697 6.447z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol